import { ShillDataItem, GroupedShillData, ShillRecord } from "./types";

/**
 * Transforms the API shill data into a grouped format by Cabal Name
 * @param data Array of ShillDataItem from the API
 * @returns Object with Cabal Names as keys and their associated data
 */
export const transformShillData = (data: ShillDataItem[]): GroupedShillData => {
  const groupedData: GroupedShillData = {};

  if (!data || !data.length) {
    return groupedData;
  }

  try {
    // Group the data by groupName
    data.forEach((item) => {
      if (!item) return;

      const {
        groupName,
        size,
        inviteLink,
        messageIds,
        senderTgUserIds,
        messageTexts,
        firstMessageAt,
        lastMessageAt,
        totalShills,
        uniqueSenderCount,
      } = item;

      if (!groupName) return;

      // Initialize the group if it doesn't exist
      if (!groupedData[groupName]) {
        groupedData[groupName] = {
          groupName,
          size: size || "--",
          inviteLink,
          records: [],
          totalShills,
          uniqueSenderCount,
        };
      }

      // Add records for this item
      if (messageIds && messageIds.length > 0) {
        // If we have multiple messageIds, create a record for each
        messageIds.forEach((messageId, index) => {
          if (!messageId) return;

          let timestamp: number;

          // Determine the timestamp for this message
          if (index === 0 && firstMessageAt) {
            timestamp = firstMessageAt;
          } else if (index === messageIds.length - 1 && lastMessageAt) {
            timestamp = lastMessageAt;
          } else {
            // For messages in the middle, use lastMessageAt as fallback
            timestamp = lastMessageAt || Date.now() / 1000;
          }

          groupedData[groupName].records.push({
            timestamp,
            messageId,
            senderTgUserId: senderTgUserIds![index],
            messageText: messageTexts![index],
          });
        });
      }
    });

    // Sort records within each group by timestamp (newest first)
    Object.keys(groupedData).forEach((groupName) => {
      groupedData[groupName].records.sort((a, b) => b.timestamp - a.timestamp);
    });

    console.log(groupedData);

    return groupedData;
  } catch (error) {
    console.error("Error transforming shill data:", error);
    return {};
  }
};
